<template>
 <div>
   <transition name="slide">
  <div class="row" v-show="weekChangeClicked"  style="margin-top:10px;">
      <template v-for="item in openDays">
          <div style="width:20%"><date-item :record="item" @dat-select-event="selectDatEvt"></date-item></div>
      </template>
  </div>
  </transition>
  <div class="row" v-if="isHideCal" style="text-align: center;">
     <div class="col-12">
         <v-calendar :attributes="attrs" :min-date="new Date()" @dayclick="dayClicked" v-model="myDate" mode="single"></v-calendar>
      </div>
  </div>
  <div class="row">&nbsp;</div>
  <div class="row">
     <div  class="col-24">
          <span style="color:#ff0000" >{{freePaces.NextFreePlaceMsg}}</span>
      </div>
      <div  class="col-24">
          <div class="product-btn" style="text-align:center" v-if="this.openDays.length === 5">
          <a  @click="loadNextFreePlace" v-bind:style="{ 'background-color': getColorApp}" style="color:#fff"><i class="ion-calendar" ></i>Volgende datums tonen</a>
          </div>
      </div>
  </div>
  <div class="row" v-if="!isHideCal">
      <div class="col-24" v-if="!isNoFreePlace">
         <cart-free-place :record="freePaces"></cart-free-place>
      </div>
      <div  class="col-24" v-else>
          <br>
          <h5>Geen tijden beschikbaar op {{this.freePaces.DateInfo}}</h5>
      </div>
  </div>

 </div>

</template>

<style>
.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}

.titleDate
{
  font-size: 15px;
  font-weight: bold;
  text-align:center;
}

.calendarpopup {
   position:fixed;
    top: 50%;
  
}


</style>

<script>
import Vue from 'vue';
import VCalendar from 'v-calendar';
import 'v-calendar/lib/v-calendar.min.css';
import myHttpApi from "../../api/myhttpapi";
import CartDateItem from "./SingleSalonCartDateItem";
import CartFreePlace from "./CartFreePlace";
import {
    SPINNER_SHOW,
    SPINNER_HIDE
  } from '../../store/mutation-types'

  export default {
    data () {
      return {
        cart: this.$store.state.cart,
        isHideCal : false,
        weekChangeClicked : true,
        datWeek : '',
        openDays : [],
        freePaces : {},
        myDate: new Date(),
        isNoFreePlace : false,
        isShowNextFreeDate : false,
        blockNavToStartOfWeek : false,
        isWeekBack : false,
        dateNextStr : '',
        attrs: [
        {
          key: 'today',
          dates: new Date()
        }
      ],
      }
    },
    components: {
        //vcalendar: VCalendar,
        dateItem : CartDateItem,
        cartFreePlace : CartFreePlace
    },
    mounted () {

      if (Vue.$selectedStore === undefined) return;

      this.datWeek = new Date ();
      this.myDate = this.datWeek;
      this.blockNavToStartOfWeek = true;
      this.loadWeekCal ();
    },
    computed: {
      getColorApp () {
           return Vue.$storeSettings.ColorApp;
       },
       getUserSelectAllowed () {
           return Vue.$storeSettings.IsHideUsers;
       }
    },
    methods: {
      selectDatEvt (evt) {
        this.isWeekBack = false;
        this.isHideCal = false;
        var dtStr = evt.DateStr;
        this.myDate = new Date (evt.Year, evt.Month - 1, evt.Day, 23,59,0);
        this.datWeek = this.myDate;
        
        if (evt.StatusID == 1)
        {
            this.isNoFreePlace = true;
            return; //Geen plaats vrij.. geen uren gekend..
        }
        this.hideUnselectedDates (dtStr, false);
        this.loadFreePlaces ();
      },
      hideUnselectedDates (dtStr, flgReset) {
        
        for (var c=0; c < this.openDays.length - 1; c++)
        {
           this.openDays[c].IsSelected = false;
           if (this.openDays[c].DateStr == dtStr) this.openDays[c].IsSelected = true;
        }
      },
      showCalendar () {
        this.isHideCal = ! this.isHideCal;
      },
      dayClicked (day) {
          this.isHideCal = false;
          this.datWeek = day.date;
          this.myDate = day;
          this.blockNavToStartOfWeek = true;
          this.loadFreePlaces ();
      },
      loadWeekCal () {
        
          const searchRec = {Year: this.datWeek.getFullYear() , Month: (this.datWeek.getMonth() + 1) , Day: this.datWeek.getDate(), SalonID: Vue.$selectedStore.UserID }
          myHttpApi.post( 'Service/GetDaysWeekSingleSalon', searchRec)
              .then(response => {
                this.weekChangeClicked = false;
                this.openDays = response.data;

                if (this.openDays.length > 0)
                {
                  this.datWeek = new Date (this.openDays[0].Year, this.openDays[0].Month - 1, this.openDays[0].Day, 23,59,0);
                  this.hideUnselectedDates (this.openDays[0].DateStr, false);
                }
              
                this.loadFreePlaces ();
                this.weekChangeClicked = true;
              })
              .catch(error => {
                console.log(error);
                this.openDays = []
                this.weekChangeClicked = true;
          });
      },
      loadNextFreePlace () {
          this.isShowNextFreeDate = true;
          this.hideUnselectedDates ("", true);
          this.datWeek = new Date (this.openDays[this.openDays.length - 1].Year, this.openDays[this.openDays.length - 1].Month - 1, this.openDays[this.openDays.length - 1].Day, 23,59,0);
          this.loadWeekCal ();
      },
      loadFreePlaces () {
          this.$store.commit(SPINNER_SHOW);
          const searchRec = {Year: this.datWeek.getFullYear() , Month: (this.datWeek.getMonth() + 1) , Day: this.datWeek.getDate(), BasketItems: this.cart, 
            SearchNext : this.isShowNextFreeDate, BackButton : this.isWeekBack, UserID: Vue.$selectedStore.UserID }
          console.log (searchRec);

          this.isShowNextFreeDate = false;
          myHttpApi.post( 'Basket/GetFreePlacesSingleSalon', searchRec)
              .then(response => {
                 this.freePaces = response.data;
                 this.isNoFreePlace = false; 

                 if (this.freePaces.Records.length <= 0) {this.isNoFreePlace = true;}
                 if (this.freePaces.IsNextFreeApp)
                 {
                   this.dateNextStr = this.freePaces.DateStr;

                   this.myDate = new Date (this.freePaces.Year, this.freePaces.Month - 1, this.freePaces.Day, 23,59,0);
                   this.datWeek = this.myDate;

                   this.datWeek.setDate (this.datWeek.getDate() + 1);
                   this.weekRecord = this.freePaces.NextWeekDays
                   this.weekChangeClicked = true;
                 }
                 this.$store.commit(SPINNER_HIDE);
              })
              .catch(error => {
                console.log(error);
                this.freePaces = [];
                this.$store.commit(SPINNER_HIDE);
          });
      }

    }
  }

 Vue.use(VCalendar, {
        firstDayOfWeek: 2
    });
 
</script>


// WEBPACK FOOTER //
// src/components/cart/SingleSalonCartDate.vue